// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <>
      <div className="app-navbar-wrapper">
        <Navbar />
      </div>
      <ScrollToTop />
      <Routes>
         <Route path="/" element={<Home />} />
      </Routes>
      <div className="app-footer-wrapper">
        <Footer />
      </div>
    </>
  );
}

export default App;
